import api from '../../api';
import { changeSubscription } from '../../ducks/paymentMethods.duck';
import { fetchCurrentUser } from '../../ducks/user.duck';

// ================ Action types ================ //

export const FETCH_SUBSCRIPTION_DETAILS_REQUEST =
  'app/PaymentMethodsPage/FETCH_SUBSCRIPTION_DETAILS_REQUEST';
export const FETCH_SUBSCRIPTION_DETAILS_SUCCESS =
  'app/PaymentMethodsPage/FETCH_SUBSCRIPTION_DETAILS_SUCCESS';
export const FETCH_SUBSCRIPTION_DETAILS_ERROR =
  'app/PaymentMethodsPage/FETCH_SUBSCRIPTION_DETAILS_ERROR';

export const STRIPE_CUSTOMER_REQUEST = 'app/PaymentMethodsPage/STRIPE_CUSTOMER_REQUEST';
export const STRIPE_CUSTOMER_SUCCESS = 'app/PaymentMethodsPage/STRIPE_CUSTOMER_SUCCESS';
export const STRIPE_CUSTOMER_ERROR = 'app/PaymentMethodsPage/STRIPE_CUSTOMER_ERROR';

export const SUBSCRIBE_REQUEST = 'app/PaymentMethodsPage/SUBSCRIBE_REQUEST';
export const SUBSCRIBE_SUCCESS = 'app/PaymentMethodsPage/SUBSCRIBE_SUCCESS';
export const SUBSCRIBE_ERROR = 'app/PaymentMethodsPage/SUBSCRIBE_ERROR';

// ================ Reducer ================ //

const initialState = {
  subscriptionDetails: null,
  subscriptionDetailsError: null,
  subscriptionDetailsInProgress: false,

  stripeCustomerFetched: false,
  stripeCustomerFetchError: null,

  subscribingInProgress: false,
  subscribingError: null,
};

export default function payoutMethodsPageReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case FETCH_SUBSCRIPTION_DETAILS_REQUEST:
      return { ...state, subscriptionDetailsInProgress: true, subscriptionDetailsError: null };
    case FETCH_SUBSCRIPTION_DETAILS_SUCCESS:
      return {
        ...state,
        subscriptionDetailsInProgress: false,
        subscriptionDetailsError: null,
        subscriptionDetails: payload,
      };
    case FETCH_SUBSCRIPTION_DETAILS_ERROR:
      console.error(payload); // eslint-disable-line no-console
      return { ...state, subscriptionDetailsInProgress: false, subscriptionDetailsError: payload };
    case STRIPE_CUSTOMER_REQUEST:
      return { ...state, stripeCustomerFetched: false };
    case STRIPE_CUSTOMER_SUCCESS:
      return { ...state, stripeCustomerFetched: true };
    case STRIPE_CUSTOMER_ERROR:
      console.error(payload); // eslint-disable-line no-console
      return { ...state, stripeCustomerFetchError: payload };
    case SUBSCRIBE_REQUEST:
      return { ...state, subscribingInProgress: true, subscribingError: null };
    case SUBSCRIBE_SUCCESS:
      return { ...state, subscribingInProgress: false };
    case SUBSCRIBE_ERROR:
      return { ...state, subscribingInProgress: false, subscribingError: payload };
    default:
      return state;
  }
}

// ================ Action creators ================ //

export const stripeCustomerRequest = () => ({ type: STRIPE_CUSTOMER_REQUEST });
export const stripeCustomerSuccess = () => ({ type: STRIPE_CUSTOMER_SUCCESS });
export const stripeCustomerError = e => ({
  type: STRIPE_CUSTOMER_ERROR,
  error: true,
  payload: e,
});

export const fetchSubscriptionDetailsRequest = () => ({ type: FETCH_SUBSCRIPTION_DETAILS_REQUEST });
export const fetchSubscriptionDetailsSuccess = payload => ({
  type: FETCH_SUBSCRIPTION_DETAILS_SUCCESS,
  payload,
});
export const fetchSubscriptionDetailsError = e => ({
  type: FETCH_SUBSCRIPTION_DETAILS_ERROR,
  error: true,
  payload: e,
});

export const subscribeRequest = () => ({ type: SUBSCRIBE_REQUEST });
export const subscribeSuccess = payload => ({ type: SUBSCRIBE_SUCCESS, payload });
export const subscribeError = e => ({ type: SUBSCRIBE_ERROR, payload: e });

// ================ Thunks ================ //

export const stripeCustomer = () => (dispatch, getState, sdk) => {
  dispatch(stripeCustomerRequest());
  const fetchCurrentUserOptions = {
    callParams: { include: ['stripeCustomer'] },
    updateHasListings: false,
    updateNotifications: false,
    enforce: true,
  };

  return dispatch(fetchCurrentUser(fetchCurrentUserOptions))
    .then(() => {
      const { stripeCustomer, attributes } = getState()?.user?.currentUser || {};
      const { email } = attributes || {};
      if (!stripeCustomer) {
        dispatch(() =>
          sdk.stripeCustomer.create({
            stripeCustomerEmail: email,
          })
        )
          .then(() => dispatch(fetchCurrentUser(fetchCurrentUserOptions)))
          .then(() => dispatch(fetchSubscriptionDetails()));
      }
      dispatch(stripeCustomerSuccess());
    })
    .catch(e => {
      const error = storableError(e);
      log.error(error, 'fetch-stripe-customer-failed');
      dispatch(stripeCustomerError(error));
    });
};

export const fetchSubscriptionDetails = () => (dispatch, getState, sdk) => {
  dispatch(fetchSubscriptionDetailsRequest());

  return api.subscriptions
    .getDetails()
    .then(response => {
      dispatch(fetchSubscriptionDetailsSuccess(response?.data));
      if (response?.data) {
        dispatch(changeSubscription());
      }
    })
    .catch(e => dispatch(fetchSubscriptionDetailsError(e)));
};

export const subscribe = values => dispatch => {
  dispatch(subscribeRequest());
  return api.subscriptions
    .subscribe(values)
    .then(response => {
      dispatch(subscribeSuccess(response.data));
      const { url } = response.data;

      if (typeof window !== 'undefined') {
        window.location.href = url;
      }
    })
    .catch(e => {
      dispatch(subscribeError(e));
    });
};

export const loadData = () => (dispatch, getState, sdk) => {
  dispatch(stripeCustomer());

  return dispatch(fetchSubscriptionDetails());
};
